module.exports = __webpack_public_path__ + "static/media/image-orange.7e5ef401.svg";